import { render, staticRenderFns } from "./ResetPasswordLayout.vue?vue&type=template&id=3ab53c8e&scoped=true&"
var script = {}
import style0 from "./ResetPasswordLayout.vue?vue&type=style&index=0&id=3ab53c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab53c8e",
  null
  
)

export default component.exports